import Page from '../components/ui/Page';
import ContentLayout from '../layouts/ContentLayout';

export default () => (
  <Page>
    <ContentLayout>
      <h2>Terms of Service</h2>
      <div className="max-w-xl mx-auto mt-5 text-sm text-left">
        <div className="mt-2 text-lg font-semibold">1. Terms</div>
        <p>
          By accessing the website at <a href="https://openroad.fyi">https://openroad.fyi</a>, you
          are agreeing to be bound by these terms of service, all applicable laws and regulations,
          and agree that you are responsible for compliance with any applicable local laws. If you
          do not agree with any of these terms, you are prohibited from using or accessing this
          site. The materials contained in this website are protected by applicable copyright and
          trademark law.
        </p>
        <div className="mt-2 text-lg font-semibold">2. Use License</div>
        <ol type="a">
          <li>
            Permission is granted to temporarily download one copy of the materials (information or
            software) on Openroad's website for personal, non-commercial transitory viewing only.
            This is the grant of a license, not a transfer of title, and under this license you may
            not:
            <ol type="i">
              <li>modify or copy the materials;</li>
              <li>
                use the materials for any commercial purpose, or for any public display (commercial
                or non-commercial);
              </li>
              <li>
                attempt to decompile or reverse engineer any software contained on Openroad's
                website;
              </li>
              <li>remove any copyright or other proprietary notations from the materials; or</li>
              <li>
                transfer the materials to another person or "mirror" the materials on any other
                server.
              </li>
            </ol>
          </li>
          <li>
            This license shall automatically terminate if you violate any of these restrictions and
            may be terminated by Openroad at any time. Upon terminating your viewing of these
            materials or upon the termination of this license, you must destroy any downloaded
            materials in your possession whether in electronic or printed format.
          </li>
        </ol>
        <div className="mt-2 text-lg font-semibold">3. Disclaimer</div>
        <ol type="a">
          <li>
            The materials on Openroad's website are provided on an 'as is' basis. Openroad makes no
            warranties, expressed or implied, and hereby disclaims and negates all other warranties
            including, without limitation, implied warranties or conditions of merchantability,
            fitness for a particular purpose, or non-infringement of intellectual property or other
            violation of rights.
          </li>
          <li>
            Further, Openroad does not warrant or make any representations concerning the accuracy,
            likely results, or reliability of the use of the materials on its website or otherwise
            relating to such materials or on any sites linked to this site.
          </li>
        </ol>
        <div className="mt-2 text-lg font-semibold">4. Limitations</div>
        <p>
          In no event shall Openroad or its suppliers be liable for any damages (including, without
          limitation, damages for loss of data or profit, or due to business interruption) arising
          out of the use or inability to use the materials on Openroad's website, even if Openroad
          or a Openroad authorized representative has been notified orally or in writing of the
          possibility of such damage. Because some jurisdictions do not allow limitations on implied
          warranties, or limitations of liability for consequential or incidental damages, these
          limitations may not apply to you.
        </p>
        <div className="mt-2 text-lg font-semibold">5. Accuracy of materials</div>
        <p>
          The materials appearing on Openroad's website could include technical, typographical, or
          photographic errors. Openroad does not warrant that any of the materials on its website
          are accurate, complete or current. Openroad may make changes to the materials contained on
          its website at any time without notice. However Openroad does not make any commitment to
          update the materials.
        </p>
        <div className="mt-2 text-lg font-semibold">6. Links</div>
        <p>
          Openroad has not reviewed all of the sites linked to its website and is not responsible
          for the contents of any such linked site. The inclusion of any link does not imply
          endorsement by Openroad of the site. Use of any such linked website is at the user's own
          risk.
        </p>
        <div className="mt-2 text-lg font-semibold">7. Modifications</div>
        <p>
          Openroad may revise these terms of service for its website at any time without notice. By
          using this website you are agreeing to be bound by the then current version of these terms
          of service.
        </p>
        <div className="mt-2 text-lg font-semibold">8. Governing Law</div>
        <p>
          These terms and conditions are governed by and construed in accordance with the laws of CA
          and you irrevocably submit to the exclusive jurisdiction of the courts in that State or
          location.
        </p>
      </div>
    </ContentLayout>
  </Page>
);
